import { registerRemotes } from '@module-federation/enhanced/runtime';
import { environment } from './environments/environment';
type Remote = { name: string; entry: string };

async function fetchModuleFederationManifestRemotes() {
  return await fetch(environment.moduleFederationManifestRoute)
    .then((res) => res.json())
    .then((result: Record<string, string>) => {
      const rawRemotes = Object.entries(result).map(([name, entry]) => ({
        name,
        entry,
      }));
      return removeMissingManifests(rawRemotes);
    })
    .then((remotes: Array<Remote>) => {
      return registerRemotes(remotes);
    })
    .catch((err) => {
      console.error('Error fetching remote manifests', err?.message);
      return null;
    });
}

/**
 * Removes any missing remotes from the manifest array
 * Performs a fetch to check if the remote is available
 * @param manifests - Array of remotes
 * @returns
 */
const removeMissingManifests = async (remotes: Array<Remote>) => {
  const goodRemotes: Array<Remote> = [];
  for (const remote of remotes) {
    const exists = await fetch(remote.entry)
      .then((res) => res.ok)
      /**
       * Handle error just in case module federation manifest errors out
       * This could be due to a network error or the remote app is down
       */
      .catch(() => false);
    if (exists) {
      goodRemotes.push(remote);
    } else {
      console.error(`Remote ${remote.name} url ${remote.entry} is missing`);
    }
  }
  return goodRemotes;
};

fetchModuleFederationManifestRemotes().then(() => import('./bootstrap').catch((err) => console.error(err)));
